<template>
  <ion-header class="ion-no-border">
    <ion-toolbar class="flex items-center h-112" color="primary">
      <div class="main-container flex items-center justify-between">
        <ion-buttons slot="start">
          <ion-button
            v-if="step > 0"
            fill="solid"
            size="small"
            color="secondary"
            shape="round"
            class="headerButton"
            @click="incidentStore.onBack"
          >
            <ion-icon
              slot="icon-only"
              :icon="chevronBack"
            />
          </ion-button>
        </ion-buttons>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
          <ion-button
            v-if="shouldShowEdit"
            fill="solid"
            size="small"
            color="secondary"
            shape="round"
            class="headerButton"
            @click="incidentStore.startEditingCompletedIncident"
          >
            <ion-icon slot="icon-only" :icon="pencil" />
          </ion-button>
          <ion-button
            v-else-if="incidentStore.editingCompletedIncident"
            fill="solid"
            size="small"
            color="secondary"
            shape="round"
            class="headerButton"
            @click="saveEdit"
          >
            <ion-icon slot="icon-only" :icon="checkmark" />
          </ion-button>
          <ion-button
            v-if="shouldShowDelete"
            fill="solid"
            size="small"
            color="secondary"
            shape="round"
            class="headerButton"
            @click="incidentStore.deleteIncident"
          >
            <ion-icon slot="icon-only" :icon="trash" />
          </ion-button>
          <ion-button
            fill="solid"
            size="small"
            color="secondary"
            shape="round"
            class="headerButton"
            @click="$emit('onClose')"
          >
            <ion-icon slot="icon-only" :icon="close" />
          </ion-button>
        </ion-buttons>
      </div>
    </ion-toolbar>
  </ion-header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IonHeader, IonToolbar, IonTitle, IonIcon, IonButton, IonButtons } from '@ionic/vue';
import { chevronBack, close, checkmark, trash, pencil } from 'ionicons/icons';
import { useIncidentStore } from '@/store/incident';
import IncidentStatus from '@/constants/incident-status';

defineProps<{
  title: string;
  step: number;
}>();

defineEmits<{
  (e: 'onClose'): void;
  (e: 'onBack'): void;
}>();

const incidentStore = useIncidentStore();

const shouldShowEdit = computed(() => {
  return incidentStore.incident?.status === IncidentStatus.Completed && !incidentStore.editingCompletedIncident;
});

const shouldShowDelete = computed(() => {
  return incidentStore.incident?.status === IncidentStatus.Completed;
});

const saveEdit = async() => {
  await incidentStore.completeIncident(4);
  incidentStore.stopEditingCompletedIncident();
};

</script>
<style scoped>
ion-button {
  --background: var(--ion-color-primary-shade);
  --color: white;
  --border-radius: 9999999px;
}
</style>
